import { render, staticRenderFns } from "./AttendeeList.vue?vue&type=template&id=63be1972&scoped=true"
import script from "./AttendeeList.vue?vue&type=script&lang=js"
export * from "./AttendeeList.vue?vue&type=script&lang=js"
import style0 from "./AttendeeList.vue?vue&type=style&index=0&id=63be1972&prod&scoped=true&lang=css"
import style1 from "./AttendeeList.vue?vue&type=style&index=1&id=63be1972&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63be1972",
  null
  
)

export default component.exports